module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl1-50.070a194d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-D-lvl1-50.png
// module id = 3396
// module chunks = 11